<script>
  import currentUser from '../stores/auth';
  import {onMount} from 'svelte'
  import createProjectsStore from '../stores/projects'
  import Message from './Message.svelte'
  import Loader from './Loader.svelte'
  import ProjectInfo from './ProjectInfo.svelte'

  let projects;
  let versions = {};
  let addNewProject = false;
  let currentlyEditedProjectIds = [];

  onMount(async () => {
    projects = await createProjectsStore();
  })

  const enableProjectEditing = projectId => currentlyEditedProjectIds = projectId !== undefined
    ? [...new Set(currentlyEditedProjectIds.concat([projectId]))]
    : currentlyEditedProjectIds;
  const disableProjectEditing = projectId => currentlyEditedProjectIds = currentlyEditedProjectIds.filter(pId => pId !== projectId);

  const getProjectForEdit = project => ({
    project_id: null,
    name: "",
    max_attempts: 3,
    start: "",
    end: "",
    startEdit: project?.start?.substr(0, 16) ?? '',
    endEdit: project?.end?.substr(0,16) ?? '',
    max_time_for_attempt: 600,
    token_validity: 28800,
    main: false,
    ...project,
  });

  function onEdit(e) {
    const projectId = e?.detail?.project_id;
    if (projectId === undefined) return;

    enableProjectEditing(projectId)
  }

  function onCancel(e) {
    const projectId = e?.detail?.project_id;

    if (projectId === undefined) return;

    disableProjectEditing(projectId)

    if (projectId === null) addNewProject = false;
    else {
      versions[projectId] = (versions[projectId] ?? 0) + 1;
    }
  }

  $: loading = projects ? projects.loading : null;
</script>

{#if $projects}
  {#if $loading}
    <Loader text="Loading..."/>
  {/if}

  {#if $currentUser}
    <section class="new-project">
      <button class="nes-btn is-error" on:click={() => {addNewProject = true; enableProjectEditing(null)}}>
        Add a new project
      </button>
    </section>
  {/if}

  <section class="message-list">
    {#if addNewProject}
      <Message type="right">
        <ProjectInfo project={{...getProjectForEdit()}}
                     editMode={currentlyEditedProjectIds.includes(null)}
                     on:edit={onEdit} on:cancel={onCancel}
        />
      </Message>
    {/if}

    {#each $projects as project, pIdx (project?.project_id + (versions[project?.project_id] ?? ''))}
      <Message type={pIdx % 2 ? 'right' : 'left'}>
        <ProjectInfo project={{...getProjectForEdit(project)}}
                     editMode={currentlyEditedProjectIds.includes(project?.project_id)}
                     on:edit={onEdit} on:cancel={onCancel}
        />
      </Message>
    {/each}
  </section>
{/if}

<style>
    .new-project {
        margin-bottom: 1rem;
    }

    .message-list :global(.message) {
        min-width: calc(85%);
    }

    h3 {
        font-size: 16px;
        margin-bottom: 1rem;
    }

    .action {
        text-align: right;
    }

    .action a {
        text-decoration: none;
    }
</style>
